<svg viewBox="0 0 20 20"><path d="M1.327 10.985h4.084v6.087H1.327zm6.631-4.484h4.084v10.571H7.958zm6.632-3.573h4.084v14.144H14.59z"/></svg>